import script from "./invoice-details.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice-details.vue?vue&type=script&setup=true&lang=js"

import "./invoice-details.vue?vue&type=style&index=0&id=3d5cadaf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5cadaf"]])

export default __exports__